<template>
  <validation-provider :rules="`required|one_of:${fontsValues.join(',')}`" :name="title" v-slot="{ errors }">
    <v-autocomplete
      hide-details="auto"
      class="text-uppercase"
      outlined
      dense
      v-model="font"
      :label="title"
      :items="availableFonts"
      required
      :error-messages="errors"
      :item-text="itemText"
      :item-value="itemValue"
      clearable
    />
  </validation-provider>
</template>

<script>
  import { ValidationProvider } from 'vee-validate'

  export default {
    name: 'FontsSelector',
    components: {
      ValidationProvider,
    },
    props: {
      title: {
        type: String,
        required: true,
      },
      value: {
        type: String,
        default: undefined,
      },
      availableFonts: {
        type: Array,
        default: () => {
          return [
            { value: 'lato', text: 'Lato' },
            { value: 'source_sans_pro', text: 'Source Sans Pro' },
            { value: 'arial', text: 'Arial' },
            { value: 'helvetica', text: 'Helvetica' },
            { value: 'verdana', text: 'Verdana' },
            { value: 'tahoma', text: 'Tahoma' },
            { value: 'trebuchet_ms', text: 'Trebuchet MS' },
            { value: 'times_new_roman', text: 'Times New Roman' },
            { value: 'georgia', text: 'Georgia' },
            { value: 'courier_new', text: 'Courier New' },
            { value: 'lucida_console', text: 'Lucida Console' },
            { value: 'comic_sans_ms', text: 'Comic Sans MS' },
            { value: 'impact', text: 'Impact' },
          ]
        },
      },
      itemText: {
        type: String,
        default: 'text',
      },
      itemValue: {
        type: String,
        default: 'value',
      },
    },
    computed: {
      font: {
        get() {
          return this.value
        },
        set(value) {
          this.$emit('input', value)
        },
      },
      fontsValues() {
        if (this.availableFonts?.[0]?.[this.itemValue]) {
          return this.availableFonts.map((font) => font?.[this.itemValue])
        }
        return this.availableFonts
      },
    },
  }
</script>
